/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsTwitchAuthOptions interface.
 */
export function instanceOfFxIdDomainSettingsTwitchAuthOptions(value) {
    if (!('ClientId' in value) || value['ClientId'] === undefined)
        return false;
    if (!('RedirectUri' in value) || value['RedirectUri'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsTwitchAuthOptionsFromJSON(json) {
    return FxIdDomainSettingsTwitchAuthOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsTwitchAuthOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ClientId': json['ClientId'],
        'RedirectUri': json['RedirectUri'],
    };
}
export function FxIdDomainSettingsTwitchAuthOptionsToJSON(json) {
    return FxIdDomainSettingsTwitchAuthOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsTwitchAuthOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ClientId': value['ClientId'],
        'RedirectUri': value['RedirectUri'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsTwitchAuthOptions.js.map